import { PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './before-well-section-wrap.style';

export interface ISharedTypes {
  isBefore: boolean;
}

interface IProps extends ISharedTypes, PropsWithChildren {
  id?: string;
}

const BeforeWellSectionWrap = ({ children, id, isBefore }: IProps) => {
  const styles = componentStyles({ isBefore });

  return (
    <Box style={styles.wrapper} id={id}>
      {children}
    </Box>
  );
};

export default BeforeWellSectionWrap;
